module.exports = __webpack_public_path__ + "img/trunk.f5815841.png";